import { render } from "./panel_loading.vue?vue&type=template&id=595215a2"
import script from "./panel_loading.vue?vue&type=script&lang=js"
export * from "./panel_loading.vue?vue&type=script&lang=js"

import "./panel_loading.vue?vue&type=style&index=0&id=595215a2&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__